import React from 'react'
import { Accordion, AccordionSummary, AccordionDetails, Typography, Stack } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import SettingsIcon from '@mui/icons-material/Settings'

const CollapsibleAdvanced = ({ title = 'Configuración avanzada', children, defaultExpanded = false }) => {
  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      disableGutters
      elevation={0}
      sx={{
        border: '1px dashed',
        borderColor: 'divider',
        borderRadius: '8px !important',
        '&:before': { display: 'none' },
        bgcolor: 'transparent',
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ minHeight: 44, px: 2 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <SettingsIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
          <Typography variant="body2" color="text.secondary" fontWeight={500}>
            {title}
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ px: 2, pt: 0, pb: 2 }}>
        {children}
      </AccordionDetails>
    </Accordion>
  )
}

export default CollapsibleAdvanced
